module.exports = __webpack_public_path__ + "img/21.67e00224.jpg";